/*
 * Erstellt ein Array von n bis m,
 * Es kann sowohl zuerst die größere
 * als auch die kleinere Zahl angegeben werden.
 */
export const arrayFromNToM = (n: number, m: number): number[] => {
  const higher = n > m ? n : m;
  const lower = n < m ? n : m;
  const res: number[] = [];
  for (let i = lower; i <= higher; i++) {
    res.push(i);
  }
  return res;
};
